import React, { FC } from 'react';
import { AddressTransactionsCard } from '../AddressTransactionsCard/AddressTransactionsCard';
import type { Network } from '@apolloGenerated';
import styles from './styles.module.scss';
import { TransactionMainInfo } from '@component/Address/ui/TransactionMainInfo/TransactionMainInfo';

type AddressInfoProps = {
  address: string;
  network: Network;
};
export const AddressInfo: FC<AddressInfoProps> = ({ address, network }) => {
  return (
    <div className={styles.addressInfo}>
      <TransactionMainInfo address={address} network={network} />
      <AddressTransactionsCard address={address} dense network={network} isSimpleView />
    </div>
  );
};
